import { render, staticRenderFns } from "./AddPost.vue?vue&type=template&id=1f278776&scoped=true&"
import script from "./AddPost.vue?vue&type=script&lang=js&"
export * from "./AddPost.vue?vue&type=script&lang=js&"
import style0 from "./AddPost.vue?vue&type=style&index=0&id=1f278776&prod&lang=scss&scoped=true&"
import style1 from "./AddPost.vue?vue&type=style&index=1&id=1f278776&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f278776",
  null
  
)

export default component.exports